/** Returns the UTF-8 byte length without depending on a platform text encoder. */
export function utf8ByteLength(value: string): number {
  let bytes = 0;
  for (const character of value) {
    const codePoint = character.codePointAt(0) ?? 0;
    bytes += codePoint <= 0x7f ? 1 : codePoint <= 0x7ff ? 2 : codePoint <= 0xffff ? 3 : 4;
  }
  return bytes;
}

/** Orders text by Unicode scalar value, which is also lexicographic UTF-8 byte order. */
export function compareUtf8Text(left: string, right: string): number {
  const leftCharacters = left[Symbol.iterator]();
  const rightCharacters = right[Symbol.iterator]();
  while (true) {
    const leftCharacter = leftCharacters.next();
    const rightCharacter = rightCharacters.next();
    if (leftCharacter.done || rightCharacter.done) {
      return leftCharacter.done === rightCharacter.done ? 0 : leftCharacter.done ? -1 : 1;
    }
    const difference =
      (leftCharacter.value.codePointAt(0) ?? 0) - (rightCharacter.value.codePointAt(0) ?? 0);
    if (difference !== 0) return difference;
  }
}
